// Example usage:

// export enum FeatureFlagNamesEnum {
//   TEST_FEATURE_ENABLED = 'TEST_FEATURE_ENABLED',
// }

// export const featureFlags = {
//   TEST_FEATURE_ENABLED: process.env.TEST_FEATURE_ENABLED?.toLowerCase() === 'true',
// }

// If checking for a flag on a *page* level, you can do something like this:

// import { FeatureFlagNamesEnum, featureFlags } from "@/lib/feature-flags"
// ...
// const isTestFeatureEnabled = featureFlags[FeatureFlagNamesEnum.TEST_FEATURE_ENABLED];
// if (!isTestFeatureEnabled) {
//   return notFound();
// }

// For feature flags at the component level, you can use the Feature component.
// NOTE - this only works in server components. If any component in the tree is a client component,
// this will *not* work in beta.pbs.org and www.pbs.org. Confusingly this will work in our amplify environments.
// You need to pass the feature flag as a prop from a server component to the root client component.

// import { FeatureFlagNamesEnum } from "@/lib/feature-flags"
// import Feature from '@/components/Feature/Feature';
// ...
// <Feature featureFlag={FeatureFlagNamesEnum.TEST_FEATURE_ENABLED} enabled>
//   <h2>Look Ma, this feature is enabled!</h2>
// </Feature>
// <Feature featureFlag={FeatureFlagNamesEnum.TEST_FEATURE_ENABLED} disabled>
//   <h2>Look Ma, no feature!</h2>
// </Feature>

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();export enum FeatureFlagNamesEnum {
  KETCH_ENABLED = 'KETCH_ENABLED',
  PBS_PATRIOTIC_LOGO_SCHEDULE_END = 'PBS_PATRIOTIC_LOGO_SCHEDULE_END',
  PBS_PATRIOTIC_LOGO_SCHEDULE_START = 'PBS_PATRIOTIC_LOGO_SCHEDULE_START',
  URGENT_MESSAGE_POPOVER_SCHEDULE_END = 'URGENT_MESSAGE_POPOVER_SCHEDULE_END',
  URGENT_MESSAGE_POPOVER_SCHEDULE_START = 'URGENT_MESSAGE_POPOVER_SCHEDULE_START',
  DISABLE_SPONSORSHIP = 'DISABLE_SPONSORSHIP',
  ACCESSIBILITY_EXPLORE_HUB_ENABLED = 'ACCESSIBILITY_EXPLORE_HUB_ENABLED',
  MYSTERY_PROMO_SCHEDULE_END = 'MYSTERY_PROMO_SCHEDULE_END',
  MYSTERY_PROMO_SCHEDULE_START = 'MYSTERY_PROMO_SCHEDULE_START',
  KETCH_HEAD_ENABLED = 'KETCH_HEAD_ENABLED',
};

export const featureFlags = {
  KETCH_ENABLED: process.env.NEXT_PUBLIC_KETCH_FOOTER_ENABLED?.toLowerCase() === 'true',
  PBS_PATRIOTIC_LOGO_SCHEDULE_END: process.env.NEXT_PUBLIC_PBS_PATRIOTIC_LOGO_SCHEDULE_END,
  PBS_PATRIOTIC_LOGO_SCHEDULE_START: process.env.NEXT_PUBLIC_PBS_PATRIOTIC_LOGO_SCHEDULE_START,
  URGENT_MESSAGE_POPOVER_SCHEDULE_END: process.env.NEXT_PUBLIC_URGENT_MESSAGE_POPOVER_SCHEDULE_END,
  URGENT_MESSAGE_POPOVER_SCHEDULE_START: process.env.NEXT_PUBLIC_URGENT_MESSAGE_POPOVER_SCHEDULE_START,
  DISABLE_SPONSORSHIP: process.env.NEXT_PUBLIC_DISABLE_SPONSORSHIP?.toLowerCase() === 'true',
  ACCESSIBILITY_EXPLORE_HUB_ENABLED: process.env.NEXT_PUBLIC_ACCESSIBILITY_EXPLORE_HUB_ENABLED?.toLowerCase() === 'true',
  MYSTERY_PROMO_SCHEDULE_END: process.env.MYSTERY_PROMO_SCHEDULE_END,
  MYSTERY_PROMO_SCHEDULE_START: process.env.MYSTERY_PROMO_SCHEDULE_START,
  KETCH_HEAD_ENABLED: process.env.NEXT_PUBLIC_KETCH_HEAD_ENABLED?.toLowerCase() === 'true',
};
